const hideOverflow = el => {
  const body = document.body
  const node = el || body

  if (node === body) {
    const gutter = window.innerWidth - body.offsetWidth

    node.style.overflow = 'hidden'
    node.style.paddingRight = `${gutter}px`
  }
}

export default hideOverflow
